<template>
    <span>
        <!-- Menú lateral que aparece sólo cuando drawer == true, siendo ésto posible sólo en ventanas sm: -->
        <v-navigation-drawer
            v-if="isAuthenticated"
            app
            v-model="drawer"
            class="grey lighten-5"
            disable-resize-watcher
        >
            <v-list dense class="pt-0">
                <v-list-item class="sip-blue" @click="onContacts">
                    <v-list-item-action>
                        <v-icon color="indigo darken-3">mdi-doctor</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Médicos de Referencia</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item class="sip-blue" @click="onVaccines">
                    <v-list-item-action>
                        <v-icon color="indigo darken-3">mdi-eyedropper-variant</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Vacunas</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item class="sip-blue" @click="onDrugs">
                    <v-list-item-action>
                        <v-icon color="indigo darken-3">mdi-pill</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Medicamentos</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item class="sip-blue" @click="onLabExams">
                    <v-list-item-action>
                        <v-icon color="indigo darken-3">mdi-clipboard-text</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Exámenes de Laboratorio</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item class="sip-blue" v-if="isAdmin" @click="onIndications">
                    <v-list-item-action>
                        <v-icon color="indigo darken-3">mdi-folder-information</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Indicaciones</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item class="sip-blue" @click="onNewPatient">
                    <v-list-item-action>
                        <v-icon color="indigo darken-3">mdi-account-plus</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Nuevo Paciente</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item class="sip-blue" @click="onAdmin">
                    <v-list-item-action>
                        <v-icon color="indigo darken-3">star_border</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Administrador</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>

                <v-list-item class="sip-blue" @click="onLogout" color="indigo darken-3">
                    <v-list-item-action>
                        <v-icon color="indigo darken-3">exit_to_app</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title color="indigo darken-3">Salir</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
        <!-- Termina menú lateral para dispositivos con ventanas sm -->

        <v-app-bar v-if="isAuthenticated" flat fixed app color="grey lighten-5" clipped-left>
            <v-app-bar-nav-icon
                v-if="isAuthenticated"
                class="hidden-md-and-up"
                @click="drawer = !drawer"
            ></v-app-bar-nav-icon>

            <router-link to="/">
                <img height="55" :src="navMainLogo" />
            </router-link>

            <v-toolbar-title v-if="isAuthenticated" class="hidden-sm-and-down">
                <div class="sip-blue title">&nbsp; {{ userName }}</div>
            </v-toolbar-title>

            <v-toolbar-title v-if="isAuthenticated" class="hidden-md-and-up">
                <div class="sip-blue subtitle-1">&nbsp; {{ userName }}</div>
            </v-toolbar-title>
        </v-app-bar>

        <!-- <v-overlay :value="overlay">
            <v-btn icon @click="overlay = false">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-overlay>-->
    </span>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'AppNavigation',
    data() {
        return {
            drawer: false,
            overlay: false
        };
    },
    methods: {
        onContacts() {
            //this.$router.push('/users');
        },
        onVaccines() {
            //this.$router.push('/companies');
        },
        onDrugs() {
            //this.$router.push('/exchangerate');
        },
        onLabExams() {
            //this.$router.push('/functions');
        },
        onIndications() {
            //this.$router.push('/roles');
        },
        onNewPatient() {
            this.$router.push('/newpatient');
        },
        onAdmin() {},
        onLogout() {
            console.log('logout');
            //this.overlay = true;
            this.$store.dispatch('logout');
        }
    },
    computed: {
        ...mapGetters([
            'navAppTitle',
            'navMainLogo',
            'isAuthenticated',
            'userName',
            'isAdmin'
        ])
    }
};
</script>

<style scoped>
h5 {
    /* color: 'indigo darken-3'; */
    color: #283593;
}
.usr-name {
    font-size: 14px;
    color: #00897b;
}
.sip-blue {
    color: #283593;
    /* indigo darken-3 */
}
</style>
